const { useSelector } = require("react-redux");
const { reactLocalStorage } = require("reactjs-localstorage");

export const useClient = () => { 
    const user_type = reactLocalStorage.get('user_type');
     const {  client } = useSelector((state) => state?.user);
     let clientData = []
     if( ['client','facility'].includes(user_type) && client?.length>0 )
     {
        clientData =[ client?.[0]?.value]
     }
    return clientData
 }
export const useFacility = () => { 
    const user_type = reactLocalStorage.get('user_type');
     const {  facility } = useSelector((state) => state?.user);
     let facilityData = []
     if(  ['facility'].includes(user_type) && facility?.length>0 )
     {
        facilityData = [facility?.[0]?.value]
     }
    return facilityData
 }